import { render, staticRenderFns } from "./Item.template.vue?vue&type=template&id=2164a5d2&scoped=true&"
var script = {}
import style0 from "./Item.template.vue?vue&type=style&index=0&id=2164a5d2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2164a5d2",
  null
  
)

export default component.exports